
import React, { useEffect, useState } from 'react';
import { Card, List, Typography, Spin, Alert, Divider } from 'antd';
import { User } from '../../types';
import api from '../../services/api';
import './ActivitySection.css';

const { Title, Text } = Typography;

interface ActivityLog {
  timestamp: string;
  ip: string;
  device: string;
  location: string;
  browser: string;
}

interface ActivitySectionProps {
  user: User;
}

const ActivitySection: React.FC<ActivitySectionProps> = ({ user }) => {
  const [activityLogs, setActivityLogs] = useState<ActivityLog[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchActivityLogs = async () => {
      try {
        const response = await api.get('/user/me/activity');
        setActivityLogs(response.data.slice(0, 4)); // Ensure the backend returns an array
      } catch (err: any) {
        console.error(err);
        setError(err.response?.data?.message || 'An error occurred while fetching activity logs.');
      } finally {
        setLoading(false);
      }
    };

    fetchActivityLogs();
  }, [user.uid]);

  return (
    <Card
      title="Account Activity"
      bordered={false}
      className="activity-card"
      bodyStyle={{ padding: '2rem' }}
    >
      {loading ? (
        <Spin tip="Loading activity logs..." />
      ) : error ? (
        <Alert message="Error" description={error} type="error" showIcon />
      ) : activityLogs.length === 0 ? (
        <Text>No activity logs available.</Text>
      ) : (
        <List
          itemLayout="vertical"
          dataSource={activityLogs}
          renderItem={(log) => (
            <List.Item className="activity-item">
              <List.Item.Meta
                title={<Text strong>{new Date(log.timestamp).toLocaleString()}</Text>}
                description={
                  <div>
                    <Text><strong>IP:</strong> {log.ip}</Text><br />
                    <Text><strong>Device:</strong> {log.device}</Text><br />
                    <Text><strong>Location:</strong> {log.location}</Text><br />
                    <Text><strong>Browser:</strong> {log.browser}</Text>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default ActivitySection;
